import React from 'react';
import ReactMarkdown from 'react-markdown';

const ContentText = ({ content }) => {
  return (
    <div className="text-content">
      <div className="text markdown">
        <ReactMarkdown>{content}</ReactMarkdown>
      </div>
    </div>
  );
};

export default ContentText;
